export enum GlobalDataExportStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Complete = 'complete',
  Failed = 'failed',
  FailedUpload = 'failed_upload'
}

export const PRETTY_DATA_EXPORT_STATUS = {

  [GlobalDataExportStatus.Pending]: 'Pending',
  [GlobalDataExportStatus.Uploading]: 'Uploading',
  [GlobalDataExportStatus.Complete]: 'Complete',
  [GlobalDataExportStatus.Failed]: 'Failed',
  [GlobalDataExportStatus.FailedUpload]: 'Failed Upload'
}
